export default __webpack_public_path__ + "static/media/9.7a60ee7c.PNG";